import '../../src/css/pages/companyPages.scss';

import '../../src/js/runtime';
import startStimulus from '../../src/js/startStimulus';

import personalDetails from '../../src/js/controllers/complaints/personal_details_controller';
import nav from '../../src/js/controllers/nav_controller';
import uploader from '../../src/js/controllers/uploader_controller';
import expander from '../../src/js/controllers/expander_controller';

startStimulus([{ 'personal-details': personalDetails }, { nav }, { uploader }, { expander }]);
